import { Badge, Grid, Paper } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import React from 'react'
import { useApp } from '../../contexts/app.context';
import { DELETE_FILE, GET_FILES, GET_FILE_TYPES } from '../../services/files';
import { groupBy } from '../../utility/util';
import InputField, { InputFieldTypes } from '../input_field';
import Table from '../table';

const COLUMNS = [
    {title: "Tipo", key: 'fileType', render: (item) => <Badge color="blue">{item.fileType?.title}</Badge>},
    {title: "Título", key: 'title'},
]

interface ListProps{}
interface ListHandle{
    refresh: () => void;
}

const List : React.ForwardRefRenderFunction<ListHandle, ListProps> = ({}, ref) => {
    const [loading, setLoading] = React.useState(false);
    const [loadingDelete, setLoadingDelete] = React.useState({});
    const [error, setError] = React.useState<any>(null);
    const [files, setFiles] = React.useState<any[]>([]);
    const [fileTypes, setFileTypes] = React.useState<any[]>([]);
    const [filters, setFilters] = React.useState({
        title: "",
        types: [],
    })
    const app = useApp();
    const clipboard = useClipboard({ timeout: 500 });

    const deleteFile = (id) => {
        setLoadingDelete(d => ({...d, [id]: true}));
        
        DELETE_FILE(id)
        .then(() => {
            setLoadingDelete(d => ({...d, [id]: false}));
            refresh()
        })
        .catch(err => {
            setLoadingDelete(d => ({...d, [id]: false}));
            alert(err.message)
        })
    }

    const loadFiles = () => {
        setError(null);
        setLoading(true);

        GET_FILES()
        .then(files => {
            setLoading(false);
            setFiles(files);
        })
        .catch(err => {
            setLoading(false);
            setError(err.message);
            showNotification({message: err.message, color: 'red'});
        })
    }

    const loadFileTypes = () => {
        GET_FILE_TYPES()
        .then(fileTypes => {
            setFileTypes(fileTypes);
        })
        .catch(err => {
            showNotification({message: err.message, color: 'red'});
        })
    }

    const refresh = () => { 
        loadFileTypes();
        loadFiles();
    }

    React.useEffect(refresh, []);

    React.useImperativeHandle(ref, () => ({
        refresh: () => { refresh(); }
    }));

    return <>
        <Grid mb="xs">
            <Grid.Col md={3} sm={12}>
                <InputField
                    title="Título"
                    placeholder='Buscar por título do arquivo'
                    name="title"
                    value={filters.title}
                    onChange={dt => setFilters(f => ({...f, ...dt}))}
                />
            </Grid.Col>
            <Grid.Col md={3} sm={12}>
                <InputField
                    title="Tipo do arquivo"
                    name="types"
                    type={InputFieldTypes.SELECT}
                    multiple
                    options={fileTypes.map(ft => ({value: ft._id, label: ft.title}))}
                    value={filters.types}
                    onChange={dt => setFilters(f => ({...f, ...dt}))}
                />
            </Grid.Col>
            <Grid.Col md={8} sm={12}>
                <Paper p="sm" mt="md">
                    <Table 
                        data={files
                            .filter(d => 
                                (d.title || "").toLowerCase().includes(filters.title.toLowerCase()) &&
                                (filters.types.length === 0 || filters.types.some((c: string) => (d.filterType.title || "").toLowerCase().includes(c.toLowerCase())))
                            )
                        }
                        columns={COLUMNS}
                        error={error}
                        loading={loading}
                        actions={[
                            {
                                onClick: ({item}) => {
                                    clipboard.copy(`${window.location.host}/f/${item._id}`);
                                    showNotification({
                                        message: "Texto copiado!",
                                        autoClose: 2000
                                    })
                                },
                                title: "Copiar link",
                                color: "blue"
                            },
                            {
                                onClick: ({item}) => {window.open(`/f/${item._id}`, "_blank")},
                                title: "Abrir arquivo",
                                color: "yellow"
                            },
                            {
                                title: "Deletar", 
                                color: "red", 
                                loading: item => Boolean(loadingDelete[item._id]), 
                                onClick: ({item}) => {
                                    app.confirmDialog(
                                        {text: "Realmente deseja deletar esse arquivo?"}, 
                                        (({confirmed}) => {
                                            if(confirmed) deleteFile(item._id);
                                        })
                                    )
                                }
                            },
                        ]}
                    />
                </Paper>
            </Grid.Col>
        </Grid>
    </>
}

export default React.forwardRef(List);